// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeroMain_wrapper__X_ID8","h2":"HeroMain_h2__9c462","body":"HeroMain_body__K7pGY","video":"HeroMain_video__ING3a"};